import { get, post } from '../../../services/request';

// Fetch Capacity Table Reports with Pagination
export const fetchCapacityTableReportsService = (payload) => {
    return post('CapacityTable/GetCapacityTableReportsWithPagination', payload);
};

// Notes Edit Service
export const fetchCapacityNotesEditService = (payload) => {
    return post('Common/GetReportNote', payload);
};

// Notes Save Service
export const fetchCapacityNotesSaveService = (payload) => {
    return post('Common/UpdateReportNote', payload);
};

// Delete Capacity Report Service
export const deleteCapacityReportService = (payload) => {
    return post(`CapacityTable/DeleteCapacityTableReport?CapacityTableID=${payload.CapacityTableID}`, { CapacityTableID: payload.CapacityTableID });
};

// Enable/Disable Capacity Table Report Service
export const enableDisableCapacityTableReportService = (payload) => {
    return post('CapacityTable/EnableDisableCapacityTableReport', payload);
};

// CoverageGapTool Data Refresh Service
export const coverageGapToolDataRefreshService = () => {
    return get('CoverageGapTool/CoverageGapToolDataRefresh');
};

// Get Rad Shift Paste Input All Dropdown List Service
export const getRadShiftPasteInputAllDDListService = (payload) => {
    return post('CapacityTable/GetRadShiftPasteInputAllDDList', payload);
};

// Get Shift Paste Input Filter Data With Pagination Service
export const getShiftPasteInputFilterDataWithPaginationService = (payload) => {
    return post('CapacityTable/GetShiftPasteInputFilterDataWithPagination', payload);
};

export const getShiftPasteInputRefreshDataWithPaginationService = (payload) => {
    return post('CapacityTable/GetShiftPasteInputRefreshDataWithPagination', payload);
};

export const publishCapacityTableReportService = (payload) => {
    return post('CapacityTable/PublishCapacityTableReport', payload);
};

// Get All Capacity Table Published Report List for Dropdown
export const getAllCapacityTablePublishedReportListService = () => {
    return get('CapacityTable/GetAllCapacityTablePublishedReportList');
};

// Get Capacity Table Report Service
export const getCapacityTableReportService = (payload) => {
    return get(`CapacityTable/GetCapacityTableReport?DemandTableID=${payload.DemandTableID}&CreatedBy=${payload.CreatedBy}`);
};

// Get Active Radiologist Data By ID Service
export const getActiveRadDataByIdService = (payload) => {
    return get(`CapacityTable/GetCapacityTableById?CapacityTableID=${payload.CapacityTableID}&TabNumber=${payload.TabNumber}`);
};

// Get Pending Radiologist Data By ID Service
export const getPendingRadDataByIdService = (payload) => {
    return get(`CapacityTable/GetCapacityTableById?CapacityTableID=${payload.CapacityTableID}&TabNumber=${payload.TabNumber}`);
};

// Get Offboarding Radiologist Data By ID Service
export const getOffboardingRadDataByIdService = (payload) => {
    return get(`CapacityTable/GetCapacityTableById?CapacityTableID=${payload.CapacityTableID}&TabNumber=${payload.TabNumber}`);
};

export const saveIsExcludedService = (payload) => {
    return post('ShiftInputDetails/SaveIsExcluded', payload);
};

// Get Duplicate Schedule Data Service
export const getDuplicateScheduleDataService = (payload) => {
    return post('CapacityTable/GetDuplicateShiftPasteInputDataWithPagination', payload);
};

// Delete Duplicate Shift Paste Input Data Service
export const deleteDuplicateShiftPasteInputDataService = (payload) => {
    return post('CapacityTable/DeleteDuplicateShiftPasteInputData', payload);
};

// Save Radiologist Shift Input Details Service
export const saveRadiologistShiftInputDetailsService = (payload) => {
    return post('ShiftInputDetails/SaveRadiologistShiftInputDetails', payload);
};

// Delete Shift Input Details Service
export const deleteShiftInputDetailsService = (payload) => {
    return post('ShiftInputDetails/DeleteShiftInputDetails', payload);
};

// Get Shift Input Details By ID Service
export const getShiftInputDetailsByIdService = (shiftInputDetailID) => {
    return get(`ShiftInputDetails/GetRadiologistShiftInputDetailsByID?ShiftInputDetailID=${shiftInputDetailID}`);
};

// Get Simulator RPCE With Pagination Service
export const getSimulatorRPCEWithPaginationService = (payload) => {
    return post('CapacityTable/GetSimulatorRPCEWithPagination', payload);
};

// Get Capacity Table Grid Data With Pagination Service
export const getCapacityTableGridDataWithPaginationService = (payload) => {
    return post('CapacityTable/GetCapacityTableGridDataWithPagination', payload);
};

// Update Radiologist Shift Input Details Service
export const updateRadiologistShiftInputDetailsService = (payload) => {
    return post('ShiftInputDetails/UpdateRadiologistShiftInputDetails', payload);
};

// Draft Capacity Table Report Service
export const draftCapacityTableReportService = (payload) => {
    return post('CapacityTable/DraftCapacityTableReport', payload);
};

// Shift Paste Input Duplicate Check Service
export const shiftPasteInputDuplicateCheckService = (payload) => {
    return get(`CapacityTable/ShiftPasteInputDuplicateCheck?DemandTableID=${payload.DemandTableID}`);
};

// Get Capacity Table Refresh Data Service
export const getCapacityTableRefreshDataService = (payload) => {
    return post('CapacityTable/GetCapacityTableRefreshData', payload);
};

// Get Simulator Worklist With Pagination Service
export const getSimulatorWorklistWithPaginationService = (payload) => {
    return post('CapacityTable/GetAvailableShiftsSimulatorWithPagination', payload);
};

// Get Capacity RPCE Details Service
export const getCapacityRPCEDetailsService = (payload) => {
    return post('CapacityTable/GetCapacityRPCEDetails', payload);
};

// Get Capacity worklist Details Service
export const getCapacityDetailsService = (payload) => {
    return post('CapacityTable/GetCapacityDetails', payload);
};

// Get All Emulator Data Service (for simulator refresh - worklist)
export const getAllEmulatorDataService = (payload) => {
    return post('CapacityTable/GetAllEmulatorData', payload);
};

// Get All Emulator RPCE Data Service (for simulator refresh - RPCE)
export const getAllEmulatorRPCEDataService = (payload) => {
    return post('CapacityTable/GetAllEmulatorRPCEData', payload);
};

// Get QGenda Tasks And Schedules Service
export const getQgendaTasksAndSchedulesService = (payload) => {
    return post('Qgenda/GetQgendaTasksAndSchedules', payload);
};

